<div class="mb-25">
  <mat-form-field>
    <mat-label>{{ config.dateLabel || label }}</mat-label>
    <input matInput [matDatepicker]="datepicker" [(ngModel)]="value">
    <mat-datepicker #datepicker/>
    <mat-datepicker-toggle [for]="datepicker" matSuffix/>
  </mat-form-field>
</div>

<div class="mb-25">
  <mat-form-field>
    <mat-label>{{ config.timeLabel || 'Vrijeme' }}</mat-label>
    <input matInput
      [matTimepicker]="timepicker"
      [(ngModel)]="value"
      [ngModelOptions]="{updateOn: 'blur'}">
    <mat-timepicker #timepicker interval="1h"/>
    <mat-timepicker-toggle [for]="timepicker" matSuffix/>
  </mat-form-field>
</div>
